module.exports = __webpack_public_path__ + "images/guangdong_banner02.jpg?ffe34142022cf7522afd12010a88675a";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/guangdong_banner02.jpg
// module id = 182
// module chunks = 1